import React from 'react';
import './InterviewFeedback.css';

const FeedbackDetails = ({ feedback, onClose }) => {
  if (!feedback) return null;
  
  // Determine interview type
  const interviewType = feedback.interviewType || 'DSA';

  return (
    <div className="modal-overlay">
      <div className="feedback-modal">
        <div className="feedback-modal-header">
          <h3>{interviewType} Interview Feedback</h3>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        <div className="feedback-modal-body">
          {/* Common scores */}
          <div className="feedback-scores">
            <div className="feedback-score-item">
              <h4>Communication</h4>
              <div className="score-display">{feedback.communicationScore}/10</div>
            </div>
          </div>
          
          {/* Type-specific scores */}
          {interviewType === 'DSA' && (
            <div className="form-section">
              <h4>DSA-Specific Feedback</h4>
              <div className="feedback-scores">
                {feedback.codingAbility && (
                  <div className="feedback-score-item">
                    <h4>Coding Ability</h4>
                    <div className="score-display">{feedback.codingAbility}/10</div>
                  </div>
                )}
                {feedback.algorithmicThinking && (
                  <div className="feedback-score-item">
                    <h4>Algorithmic Thinking</h4>
                    <div className="score-display">{feedback.algorithmicThinking}/10</div>
                  </div>
                )}
                {feedback.problemSolvingApproach && (
                  <div className="feedback-score-item">
                    <h4>Problem Solving Approach</h4>
                    <div className="score-display">{feedback.problemSolvingApproach}/10</div>
                  </div>
                )}
                {feedback.timeComplexityAnalysis && (
                  <div className="feedback-score-item">
                    <h4>Time Complexity Analysis</h4>
                    <div className="score-display">{feedback.timeComplexityAnalysis}/10</div>
                  </div>
                )}
              </div>
            </div>
          )}
          
          {interviewType === 'System Design' && (
            <div className="form-section">
              <h4>System Design-Specific Feedback</h4>
              <div className="feedback-scores">
                {feedback.requirementsGathering && (
                  <div className="feedback-score-item">
                    <h4>Requirements Gathering</h4>
                    <div className="score-display">{feedback.requirementsGathering}/10</div>
                  </div>
                )}
                {feedback.architectureDesign && (
                  <div className="feedback-score-item">
                    <h4>Architecture Design</h4>
                    <div className="score-display">{feedback.architectureDesign}/10</div>
                  </div>
                )}
                {feedback.scalabilityConsiderations && (
                  <div className="feedback-score-item">
                    <h4>Scalability Considerations</h4>
                    <div className="score-display">{feedback.scalabilityConsiderations}/10</div>
                  </div>
                )}
                {feedback.tradeoffAnalysis && (
                  <div className="feedback-score-item">
                    <h4>Tradeoff Analysis</h4>
                    <div className="score-display">{feedback.tradeoffAnalysis}/10</div>
                  </div>
                )}
              </div>
            </div>
          )}
          
          {interviewType === 'Behavioral/Leadership' && (
            <div className="form-section">
              <h4>Behavioral/Leadership-Specific Feedback</h4>
              <div className="feedback-scores">
                {feedback.situationalAwareness && (
                  <div className="feedback-score-item">
                    <h4>Situational Awareness</h4>
                    <div className="score-display">{feedback.situationalAwareness}/10</div>
                  </div>
                )}
                {feedback.leadershipSkills && (
                  <div className="feedback-score-item">
                    <h4>Leadership Skills</h4>
                    <div className="score-display">{feedback.leadershipSkills}/10</div>
                  </div>
                )}
                {feedback.teamworkAbility && (
                  <div className="feedback-score-item">
                    <h4>Teamwork Ability</h4>
                    <div className="score-display">{feedback.teamworkAbility}/10</div>
                  </div>
                )}
                {feedback.conflictResolution && (
                  <div className="feedback-score-item">
                    <h4>Conflict Resolution</h4>
                    <div className="score-display">{feedback.conflictResolution}/10</div>
                  </div>
                )}
              </div>
            </div>
          )}
          
          {/* Common feedback sections */}
          <div className="feedback-section">
            <h4>Strengths</h4>
            <p>{feedback.strengths}</p>
          </div>
          
          <div className="feedback-section">
            <h4>Areas of Improvement</h4>
            <p>{feedback.areasOfImprovement}</p>
          </div>
          
          {feedback.additionalComments && (
            <div className="feedback-section">
              <h4>Additional Comments</h4>
              <p>{feedback.additionalComments}</p>
            </div>
          )}
          
          <div className="feedback-modal-actions">
            <button 
              className="btn-primary" 
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackDetails;
